var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-3",attrs:{"color":"lighten-4"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":_vm.width,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }